import Consts from "./Consts";
const url = Consts.TEST ? "http://192.168.1.6:8090/newapi": "https://vinroyaltech.com/vinroyal-api";
export const call_web_service = async (params) => {
  const response = await fetch(url,
  {
    // headers: {
    //   'Content-Type': 'application/json'
    // },
    // mode: 'no-cors',
    method: "POST", 
    body: JSON.stringify(params),
  }
);
const responseJson = await response.json();
if(responseJson.status_code==1){
  return responseJson.data;
}else{
  return responseJson;
}
 
};
 

